export default __webpack_public_path__ + "static/media/advisory-board-img4.41e169c6.jpg";